import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import axios from "axios";
import { FETCH_CATEGORIES } from "../_actions/endpoints";
import TLDRInfiniteScroll from "../_components/common/TLDRInfiniteScroll";
import { StyledAICategories } from "../_components/styled/styles";
import Format from "string-format";
import { CATEGORY_COPY } from "../_components/details/constants";
import {
  toPascalCase,
} from "../_utils/common";
import { fetchAiTemplates, resetDocument } from "../_actions/aiDocumentActions";
import queryString from "query-string";
import { isEmpty } from "lodash";
import { useParams, useLocation, useHistory } from "react-router-dom";

import { handleHTTPError } from "../_actions/errorHandlerActions";
import {
  Button,
  Flex,
  Box,
  Icon,
  Text,
  IconButton,
  Spinner,
  InputGroup,
  InputLeftElement,
  Input,
  InputRightElement,
} from "@chakra-ui/react";
import { FaPencilAlt } from "react-icons/fa";
import * as ReactIcon from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { MAIN_CONTAINER_SCROLLABLE_TARGET_ID } from "../_utils/constants";
import TldrWriterCard from "./TldrWriterCard";
import {
  AI_SEARCH_BY_CATEGORY,
  AI_WRITER,
  AI_WRITER_SCREEN,
} from "../_utils/routes";
import TLDRSwiper from "../_components/common/TLDRSwiper";
import ShortformBreadcrumb from "./AiShortFormBreadcrumb";
import useDebounce from "../_hooks/useDebounce";
import { RequestTemplateContent, TldrBeatLoader } from "../_components/common/statelessView";
import { primary } from "../_components/styled/variable";
import { StyledSpinner } from "../_components/styled/ai/styledAi";

export const AiShortFormPanel = (props) => {
  let signalToken = axios.CancelToken.source();
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const querySearchParam = queryString.parse(location.search).search;
  const { loadMore, page } = props;
  const { t } = useTranslation(["ai", "common"]);
  const [loading, isLoaded] = useState(false);
  const [categories, setCategories] = useState([]);
  const [searchText, setSearchText] = useState(querySearchParam);
  const [templates, setTemplates] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [categoryDetail, setCategoryDetail] = useState({
    category: {},
    requestedCategory: params.category ? params.category : "all",
  });
  const { category, requestedCategory } = categoryDetail;
  const searchValueDebounced = useDebounce(searchText, 300);

  useEffect(() => {
    fetchCategories(CATEGORY_COPY);
    return () => {
      signalToken.cancel("The user aborted a request.");
      props.resetAiTemplates();
    };
  }, []);

  useEffect(() => {
    if (searchText && page < 2) {
      setTemplates(props.aiTemplates);
    } else {
      setTemplates([...templates, ...props.aiTemplates]);
    }
  }, [props.aiTemplates]);

  function getFilteredCategory(categories) {
    let categoryDetail = "";
    if (requestedCategory && requestedCategory !== "all") {
      let selectedCategory = categories.find(
        (a) => a.title === requestedCategory.toLowerCase()
      );
      categoryDetail = selectedCategory ?? "";
      setCategoryDetail({
        category: categoryDetail,
      });
    }
    return categoryDetail;
  }

  function fetchCategories() {
    axios.get(Format(FETCH_CATEGORIES, CATEGORY_COPY), {
        cancelToken: signalToken.token,
      }).then((res) => {
        if (res.data.results) {
          let newResults = res.data.results;
          setCategories(
            [{ id: "all", title: "all", display_name: "All" }].concat(
              newResults
            )
          );
          const categoryDetail = getFilteredCategory(newResults);
          if (category?.id !== undefined) {
            fetchAiTemplates(category.id, 1, searchText);
          } else {
            fetchAiTemplates(categoryDetail.id, 1, searchText);
          }
        }
      })
      .catch((error) => {});
  }

  function fetchAiTemplates(key = "", page, searchTerm) {
    props.resetAiTemplates();
    isLoaded(false);
    props.fetchAiTemplates(props, key, signalToken, page, searchTerm)
    .then(() => {
        isLoaded(true);
    });
  }

  function loadMoreData() {
    const categoryDetail = getFilteredCategory(categories);
    fetchAiTemplates(categoryDetail?.id, page, searchText);
  }

  const onFilterChange = (key) => {
    if (key.id === "all") props.resetAiTemplates();
    setTemplates([]);
    setCategoryDetail(
      {
        category: key,
        requestedCategory: key.title,
      },
      filterOrSearchTemplates(searchText, key)
    );
  };

  const filterOrSearchTemplates = (searchtext, selectedCategory, id) => {
    let querySearchParam;
    querySearchParam = searchtext?.length > 0 ? searchtext : queryString.parse(location.search).search;

    let url = Format(
      AI_SEARCH_BY_CATEGORY,isEmpty(selectedCategory) ? "all" : selectedCategory.title
    );
    history.replace({
      pathname: encodeURI(url),
      search: searchtext?.length > 1 ? `?search=${querySearchParam}` : "",
    });
    fetchAiTemplates(
      selectedCategory?.id === "all" ? "" : selectedCategory?.id,1,searchtext
    );
  };

  useEffect(() => {
    setTemplates([]);
    if (searchValueDebounced?.length >= 0) {
      filterOrSearchTemplates(searchValueDebounced, category);
    }
  }, [searchValueDebounced]);

  function clearSearch() {
    setSearchText("");
    setTemplates([]);
    props.resetAiTemplates();
  }

  function handleChange(e) {
    setSearchText(e.target.value);
  }

  const childElements = templates.map((result) => {
    return (
      <TldrWriterCard
        key={`${result.id}`}
        icon={
          result?.content?.icon
            ? ReactIcon[`Fa${toPascalCase(result.content.icon)}`]
              ? ReactIcon[`Fa${toPascalCase(result.content.icon)}`]
              : FaPencilAlt
            : FaPencilAlt
        }
        title={result.title}
        description={result.description}
        iconColor={result?.content?.color}
        onClick={() =>
          history.push({
            pathname: Format(AI_WRITER_SCREEN, result.slug),
            state: result,
          })
        }
      />
    );
  });

  const categoriesView = categories?.length > 0 &&
    categories.map((cat, index) => {
      return (
        <StyledAICategories>
        <Button
          key={index}
          variant="outline"
          borderRadius="full"
          color="gray.100"
          borderColor={
            category?.id === cat.id ||
            category?.title === cat.title ||
            requestedCategory === cat.title
              ? "primary.400"
              : "transparent"
          }
          _hover={{ bg: "none", borderColor: "primary.400" }}
          _focus={{ bg: "none" }}
          _active={{ bg: "none" }}
          onClick={() => onFilterChange(cat)}
        >
          {cat.display_name}
        </Button>
        </StyledAICategories>
      );
    });

  let viewAllTemplateCategoriesSwiperParams = {
    slidesPerView: "auto",
    freeMode: true,
    shouldSwiperUpdate: true,
    runCallbacksOnInit: true,
    mousewheel: false,
    containerClass: "ai-shortform-swiper-container",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      disabledClass: "swiper-button-disabled",
    },
    marginLeft: 0,
  };

  return (
    <>
      {!loading &&  <StyledSpinner width="150px"><TldrBeatLoader bgColor={primary}/></StyledSpinner>}

      <Flex
        justify="space-between"
        align="center"
        margin={props.isMobileView ? "1rem" : "1.5rem"}
      >
        {!props.isMobileView && (
          <Flex align="top">
            <IconButton
              variant="secondary"
              icon={<ReactIcon.FaArrowLeft />}
              onClick={() => history.push(AI_WRITER)}
              borderRadius="full"
            />
            <Flex direction="column" align="flex-start" ml={5}>
              <ShortformBreadcrumb category={category} />
              <Text fontSize="1.5rem" fontWeight="500" color="gray.100">
                {searchText?.length > 0
                  ? `"${searchText}"`
                  : props.isMobileView
                  ? "AI"
                  : "All"}{" "}
                templates
              </Text>
            </Flex>
          </Flex>
        )}
        {props.isMobileView && !isSearchOpen && (
          <Flex align="center">
            <Icon
              as={ReactIcon.FaArrowLeft}
              onClick={() => history.push(AI_WRITER)}
            />
            <Flex direction="column" align="flex-start" ml={5}>
              <Text fontSize="1rem" fontWeight="500" color="gray.100">
                {searchText?.length > 0 ? `"${searchText}"` : "AI"} templates
              </Text>
            </Flex>
          </Flex>
        )}
      {!props.isMobileView || isSearchOpen ? (
          <Flex
            m="0"
            alignItems="center"
            h="fit-content"
            w={props.isMobileView ? "100%" : "20%"}
          >
            <InputGroup color="white">
              <InputLeftElement
                children={
                  props.isMobileView && isSearchOpen ? (
                    <ReactIcon.FaChevronLeft
                      size={14}
                      onClick={() => {
                        setIsSearchOpen(false);
                      }}
                    />
                  ) : (
                    <ReactIcon.FaSearch />
                  )
                }
              />
              <Input
                placeholder={
                  props.isMobileView
                    ? t("templates.search.mobile")
                    : t("templates.search.other")
                }
                aria-label="Search"
                onChange={handleChange}
                value={searchText || ""}
                autoFocus={true}
              />
              {searchText?.length > 0 && (
                <InputRightElement
                  children={<ReactIcon.FaTimesCircle onClick={clearSearch} />}
                />
              )}
            </InputGroup>
          </Flex>
        ) : (
          <ReactIcon.FaSearch
            className="ai-templates-search-btn"
            onClick={() => {
              setIsSearchOpen(true);
            }}
          />
        )}
      </Flex>
      {categories?.length > 0 && 
        <Flex width="100%">
          <TLDRSwiper swiperParams={viewAllTemplateCategoriesSwiperParams}>
           {categoriesView}
          </TLDRSwiper>
        </Flex>
      }

      <Box p={props.isMobileView ? "0 1rem 1rem 1rem" : "1.5rem"} mt={["4","4","0"]}>
        {childElements.length>0 ? 
        <TLDRInfiniteScroll
          className={`ai-new-document-infinite-scroll`}
          childrens={childElements}
          hasMore={loadMore}
          loadMoreData={loadMoreData}
          scrollableTarget={MAIN_CONTAINER_SCROLLABLE_TARGET_ID}
          loaded={false}
        />
        :
      loading && 
      <Box mt="20%">
        <RequestTemplateContent text={t("featured_templates.no_templates",{ns:"common"})}/>
      </Box>}
      </Box>
    </>
  );
};

AiShortFormPanel.propTypes = {
  auth: PropTypes.object.isRequired,
  aiTemplates: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  aiTemplates: state.document.aiTemplates,
  page: state.document.page,
  loadMore: state.document.loadMore,
  subscription: state.subscription,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAiTemplates: (props, key, signalToken, page, searchTerm) =>
    dispatch(fetchAiTemplates(props, key, signalToken, page, searchTerm)),
  resetAiTemplates: () => dispatch(resetDocument()),
  handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AiShortFormPanel);
